import type { ArticleV2, CoreImageData } from 'types/capi/article';

import Image from '~/components/Image';

type Props = {
  articleType?: ArticleV2['article_type'];
  images: CoreImageData[];
};

export default function HeaderImage({ images, articleType }: Props) {
  if (articleType === 'news') {
    return <PaddedHeaderImage images={images} />;
  }

  return <FullWidthHeaderImage images={images} />;
}

function FullWidthHeaderImage({ images }: { images: CoreImageData[] }) {
  const { desktop, main } = getFullWidthImages(images);

  return (
    <div className="relative">
      <Image
        alt={desktop.alt}
        src={desktop.url}
        responsiveOptions={{
          md: { src: desktop.url },
          xs: { src: main.url }
        }}
        progressiveLoadSettings={{ highResQuality: 100, lowResQuality: 50 }}
        className="xs:h-[141px] z-0 w-full object-cover md:h-[288px] lg:h-[384px] xl:h-[540px]"
        loading="eager"
      />
      {main.caption && (
        <span className="absolute bottom-4 z-10 ml-4 text-xs font-semibold text-grey-hide">
          {main.caption}
        </span>
      )}
    </div>
  );
}

function PaddedHeaderImage({ images }: { images: CoreImageData[] }) {
  const image = images.find((img) => img.ratio === '16:9')!.image;

  return (
    <div className="flex flex-col items-center bg-grey-tile px-4 pt-6 sm:px-8">
      <Image
        alt={image.alt}
        src={image.url}
        progressiveLoadSettings={{ highResQuality: 100, lowResQuality: 50 }}
        className="max-h-[200px] md:max-h-[400px] lg:max-h-[635px]"
        loading="eager"
      />
      {image.caption && (
        <span className="mt-2 block text-xs font-semibold text-grey-hide">
          {image.caption}
        </span>
      )}
    </div>
  );
}

function getFullWidthImages(images: CoreImageData[]) {
  const main = images.find((img) => img.ratio === '16:9')!.image;
  const desktop = images.find((img) => img.ratio === '8:3')!.image;

  return { desktop, main };
}
